module.exports = __webpack_public_path__ + "static/media/channel-assistants.b250d4df.svg";